import useGlobalContext from "./useGlobalContext";
import { isOfKayakOrigin } from "../utils/marketing-url-params";
import { flightsSessionStore, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { UIFetchStatus, UIFlightData } from "@flights/types";
import useRetryFlightDetailsApi from "./useRetryFlightDetailsApi";

// Add the click id param to make a price accuracy S2S call
const useKayakS2SParams = (
  fetchStatus: UIFetchStatus,
  flight: UIFlightData | undefined,
  landingMetaOffer: unknown,
  searchParams: URLSearchParams,
  params?: { id: string; airports: string }
) => {
  const { marketingTrackingVariables } = useGlobalContext();
  const { isRetryableFlightDetails } = useRetryFlightDetailsApi();

  if (
    isOfKayakOrigin() &&
    isFeatureRunningClientSide("FLIGHTS_WEB_CAT_ENABLE_KAYAK_S2S_CALL_FE") && //fetchStatus === "failed" && !(flight && isRetryableFlightDetails())
    (fetchStatus === "success" || fetchStatus === "failed") &&
    params?.id === landingMetaOffer &&
    marketingTrackingVariables?.externalTracking &&
    !flightsSessionStore.get("kayak_s2s_fired")
  ) {
    marketingTrackingVariables.externalOrigin &&
      searchParams.set("externalOrigin", marketingTrackingVariables.externalOrigin);
    searchParams.set("extTr", marketingTrackingVariables.externalTracking);
    searchParams.set(
      "resultType",
      fetchStatus === "failed" && !(flight && isRetryableFlightDetails()) ? "not_found" : "found"
    );
    flightsSessionStore.set("kayak_s2s_fired", true);
  }
};

export default useKayakS2SParams;
